import { sidebarUrlParamsSchema } from "@grafit/shared/utils/sidebar-url-params-schema";
import { tidSchemaFactory } from "@grafit/shared/utils/validation";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { BidRowsDrawer } from "../../../features/bid-rows-drawer/bid-rows-drawer";
import { BidRowsDrawerNavigationProvider } from "../../../features/bid-rows-drawer/use-bid-rows-drawer-navigation";
import {
  PURCHASE_DRAWER_TRANSLATIONS,
  useMatchingPurchaseBidRows,
  usePurchaseDrawerUrlParams,
} from "../../../features/purchase-drawer/use-purchase-drawer";

const purchasesRouteSearchSchema = sidebarUrlParamsSchema.extend({
  nameFilter: z.string().optional(),
  selectedPurchaseId: tidSchemaFactory("purchase").optional(),
});

const purchasesRouteSearchSchemaValidator = zodValidator(purchasesRouteSearchSchema);

const PurchasesLayout = () => {
  const { selectedPurchaseId, resetSelectedPurchaseId } = usePurchaseDrawerUrlParams();
  const matching = useMatchingPurchaseBidRows(selectedPurchaseId);

  return (
    <BidRowsDrawerNavigationProvider>
      <BidRowsDrawer
        selectedId={selectedPurchaseId}
        resetSelectedId={resetSelectedPurchaseId}
        matching={matching}
        translations={PURCHASE_DRAWER_TRANSLATIONS}
      >
        <Outlet />
      </BidRowsDrawer>
    </BidRowsDrawerNavigationProvider>
  );
};

export const Route = createFileRoute("/_auth/_project/purchases/$projectId/$subProjectId")({
  component: PurchasesLayout,
  validateSearch: purchasesRouteSearchSchemaValidator,
});
